var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaybtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4609 18.9753L17.6069 14.0268C17.3747 13.8886 17.0863 13.9116 16.8686 13.9116C15.9976 13.9116 16.0015 14.5841 16.0015 14.7544V24.8686C16.0015 25.0127 15.9977 25.7115 16.8686 25.7115C17.0863 25.7115 17.3747 25.7345 17.6069 25.5963L25.4608 20.6478C26.1055 20.2642 25.9941 19.8115 25.9941 19.8115C25.9941 19.8115 26.1055 19.3588 25.4609 18.9753Z",
    fill: "#3288CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybtn);
export default __webpack_public_path__ + "static/media/playbtn.3d6611bae00cf55ce25db9cb4c024e1a.svg";
export { ForwardRef as ReactComponent };